import { ADMIN_TABS, AdminTab } from './adminTabs';
import './AdminHome.css'
export const AdminMobileMenu = ({
  activeTab,
  onNavigate
}: {
  activeTab: AdminTab;
  onNavigate: (path: string) => void;
}) => {
  return (
    <div className="admin-mobile-menu">
      {ADMIN_TABS.map(tab => (
        <button
          key={tab.id}
          className={`admin-mobile-item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onNavigate(tab.path)}
        >
          <tab.icon size={18} className="admin-mobile-item-icon" />
          <span>{tab.label}</span>
        </button>
      ))}
      <div className="admin-mobile-footer">
  <button
    className="admin-mobile-item"
    onClick={() => onNavigate('/')}
  >
    ← Tillbaka till portalen
  </button>
</div>
    </div>
  );
};
